import React from "react";
import styles from "../Login.module.scss";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import FormTextfield from "../../../components/FormComponents/FormTextfield/FormTextfield";
import ExSwitch from "../../../components/FormComponents/ExSwitch/ExSwitch";
const RegistrationForm = (props) => {
  return (
    <div className={styles["form"]}>
      <p className={styles["heading"]} isreg="yes">
        Oppure REGISTRATI con...
      </p>
      <div className={styles["icon-buttons"]}>
        <button className={styles["social-buttons"]}>
          <FcGoogle size={18} />
          <p className={styles["button-text"]}>Google</p>
        </button>
        <button className={styles["social-buttons"]}>
          <FaFacebook size={18} color="#316FF6" />
          <p className={styles["button-text"]}>Facebook</p>
        </button>
      </div>
      <div className={styles["textfield"]}>
        <FormTextfield label="Nome" />
      </div>
      <div className={styles["textfield"]}>
        <FormTextfield label="Cognome" />
      </div>
      <div className={styles["textfield"]}>
        <FormTextfield label="Email" />
      </div>
      <div className={styles["textfield"]}>
        <FormTextfield label="N° celullare" />
      </div>
      <div className={styles["textfield"]}>
        <div className={styles.flex}>
          <div className={styles.switchContainer}>
            <ExSwitch
              isEnabled={true}
              switchType={"primary"}
              labelPlacement={"start"}
            />
          </div>
          <p className={styles.paragraph}>
            Accetto i Termini e Condizioni d'Uso e la Privacy Policy
          </p>
        </div>
      </div>
      <button
        className={styles["submit-button"]}
        onClick={() => props.setConfirmButtonClicked(true)}
      >
        registrati
      </button>
    </div>
  );
};

export default RegistrationForm;
